// 고객사 리포트 (현장앱 구글 시트 수집분) — API 클라이언트.
import type {
  CustomerSheetReportCandidatesResponse,
  CustomerSheetReportDto,
  ListCustomerSheetReportsQuery,
  ListCustomerSheetReportsResponse,
  MergeCustomerSheetReportResult,
  UpdateCustomerSheetReportDto,
} from '@bhops/shared';
import { apiClient } from './client';

export const customerSheetReportsApi = {
  async list(q: ListCustomerSheetReportsQuery): Promise<ListCustomerSheetReportsResponse> {
    const { data } = await apiClient.get<ListCustomerSheetReportsResponse>(
      '/customer-sheet-reports',
      { params: q },
    );
    return data;
  },

  async update(id: string, dto: UpdateCustomerSheetReportDto): Promise<CustomerSheetReportDto> {
    const { data } = await apiClient.patch<CustomerSheetReportDto>(
      `/customer-sheet-reports/${id}`,
      dto,
    );
    return data;
  },

  /**
   * 캘린더 유지보수의 '기존 리포트에 잇기' 후보(2026-11-03) — 그 고객사와 매장명이 맞는 처리 안 된 리포트.
   */
  async candidates(customerId: string): Promise<CustomerSheetReportCandidatesResponse> {
    const { data } = await apiClient.get<CustomerSheetReportCandidatesResponse>(
      '/customer-sheet-reports/candidates',
      { params: { customerId } },
    );
    return data;
  },

  /** 같은 건 합치기(2026-11-03) — 캘린더가 만든 리포트(id)를 다른 리포트(targetId)에 합친다. */
  async merge(id: string, targetId: string): Promise<MergeCustomerSheetReportResult> {
    const { data } = await apiClient.post<MergeCustomerSheetReportResult>(
      `/customer-sheet-reports/${id}/merge`,
      { targetId },
    );
    return data;
  },

  /** 소프트 삭제 — 행은 남고 목록에서만 사라진다. 되돌림은 서버의 restore. */
  async remove(id: string): Promise<{ id: string; deletedAt: string | null }> {
    const { data } = await apiClient.delete<{ id: string; deletedAt: string | null }>(
      `/customer-sheet-reports/${id}`,
    );
    return data;
  },
};
